module.exports = __webpack_public_path__ + "img/Tresemme.21f04ba7.svg";